import "./_style.scss";
import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { headTitleList } from "./parts";
import TkTable from "../../components/atoms/TkTable";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import { httpAPI_AGE005, httpAPI_AGE008 } from "./api/request";
import { IAPI_AGE005_Request, IAPI_AGE008_Request } from "../../type/apiType";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { handleGetbodyList } from "./hooks/useHooks";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkDialog from "../../components/atoms/TkDialog";

/**
 * SCRC100001 代行者への処理依頼
 * @return SCRC100001 代行者への処理依頼
 */
const SCRC100001 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessStete } =
    useContext(BusinessContext);
  const [bodyList, setbodyList] = useState<any>([]);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const handleRerequest = (item: any) => {
    setBusinessStete({
      ...businessState,
      agentOther: {
        agentRequestId: item.taskId,
      },
    });
    navigate("/SCRC100006", {
      state: { taskId: item.taskId, requisitionProcess: "1" },
    });
  };

  const handleReferenceRequest = (item: any) => {
    setBusinessStete({
      ...businessState,
      agentOther: {
        agentRequestId: item.taskId,
      },
    });
    navigate("/SCRC100006", {
      state: { taskId: item.taskId, requisitionProcess: "0" },
    });
  };

  const handleClick = (item: any) => {
    setBusinessStete({
      ...businessState,
      agentOther: {
        agentRequestId: item.taskId,
      },
    });
    navigate("/SCRC100004", { state: { taskId: item.taskId } });
  };

  const handleNewRequest = () => {
    navigate("/SCRC100005");
  };

  const handleNewRegistration = () => {
    navigate("/SCRC100002");
  };

  const handleRequestCancelClick = (item: any) => {
    setSelectedItem(item);
    setOpenDialog(true);
  };

  const RequestCancel = async () => {
    if (!selectedItem) {
      return;
    }
    const paramData: IAPI_AGE008_Request = {
      taskId: selectedItem.taskId,
    };
    try {
      const res = await httpAPI_AGE008({
        ...paramData,
      });
      if (res.resultCd === "I0000") {
        handleInit();
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    } finally {
      setOpenDialog(false);
    }
  };

  const handleInit = async () => {
    const paramData: IAPI_AGE005_Request = {
      contractorNo: state.authInfo?.contractorNo + "",
    };
    try {
      const res = await httpAPI_AGE005({
        ...paramData,
      });
      if (res.resultCd === "I0000") {
        const listData = res.agentRequestList || [];
        setbodyList(
          handleGetbodyList(
            listData,
            handleRerequest,
            handleReferenceRequest,
            handleClick,
            handleRequestCancelClick
          )
        );
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRC100001" data-testid="SCRC100001PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC100001_01}</TkInfoManual>
      <Box className="btns">
        <TkButton onClick={handleNewRequest} data-testid="SCRC100001New">
          新規依頼
        </TkButton>
        <TkButton onClick={handleNewRegistration}>
          代行者一覧・新規登録
        </TkButton>
      </Box>
      <Box className="table">
        <TkTable headList={headTitleList} bodyList={bodyList}></TkTable>
      </Box>
      <Box className="backBtn">
        <TkBackButton></TkBackButton>
      </Box>
      <TkDialog
        open={openDialog}
        title="確認（代行依頼を取消します）"
        contextText="　代行依頼の取消を行いますが、問題ないでしょうか。"
        okText="はい"
        cancelText="いいえ"
        onSave={RequestCancel}
        onCancel={() => setOpenDialog(false)}
      />
    </Box>
  );
};

export default SCRC100001;
